// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"a26e1f6e","211":"cc0964c7"}[chunkId] + ".chunk.js";
};